<template>
  <BCard
    no-body
    class="rs-collapse-lite rs-custom-card"
  >
    <BCardHeader
      :class="`p-0 ${headerClass}`"
    >
      <div
        class="row m-0 align-items-center "
      >
        <div
          v-show="hasDrag"
          class="col flex-grow-0 cursor-grabbing "
        >
          <i class="fas fa-grip-vertical rs-text-secondary-light" />
        </div>

        <div
          :class="`col p-0 ${noDragClass} `"
        >
          <BButton
            :id="`${id}_toggle`"
            block
            :class="`${headerClass}`"
            @click="$emit('input', !value)"
          >
            <slot name="title" />
            <div
              v-if="theLabel"
              :class="`row m-0 align-items-center` "
            >
              <div
                v-show="hasSwitch"
                class="col p-0 flex-grow-0 mr-3"
              >
                <RsFormSwitch
                  :id="`${id}_switch`"
                  :model-value="value"
                  :true-value="true"
                  :false-value="false"
                  class="mb-0"
                  @change="$emit('input', !value)"
                />
              </div>
              <div
                v-show="icon"
                class="col p-0 flex-grow-0 mr-3"
              >
                <i :class="icon" />
              </div>

              <div
                class="col p-0 text-truncate"
              >
                {{ theLabel }}
                <i
                  v-show="listingScoresHeart"
                  :id="`${id}_lsCollapse`"
                  class="far fa-heartbeat ml-1"
                >
                  <RsTooltip
                    v-if="listingScoresHeart"
                    :target="`${id}_lsCollapse`"
                    position="right"
                    :title="listingScoresText"
                  />
                </i>
              </div>

              <div class="`col p-0 ml-3 flex-grow-0">
                <i
                  v-show="value"
                  :class="toggleUpIcon"
                />
                <i
                  v-show="!value"
                  :class="toggleDownIcon"
                />
              </div>
            </div>
          </BButton>
        </div>
      </div>
    </BCardHeader>
    <BCollapse
      v-if="renderType === 'if' ? value : true"
      :id="`${id}`"
      :visible="value"
    >
      <BCardBody :class="`border-top ${noDragClass} ${bodyClass}`">
        <slot />
      </BCardBody>
    </BCollapse>
  </BCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { decodeHtml } from '@/shared';

export default defineComponent({
  name: 'RsCollapseLite',

  props: {
    id: {
      type: String,
      required: true,
    },

    label: {
      type: String,
    },

    icon: {
      type: String,
      default: '',
    },

    value: {
      type: Boolean,
      default: false,
    },

    hasDrag: {
      type: Boolean,
      default: false,
    },

    listingScoresHeart: {
      type: Boolean,
      default: false,
    },

    listingScoresText: {
      type: String,
      default: '',
    },

    hasSwitch: {
      type: Boolean,
      default: false,
    },

    noDragClass: {
      type: String,
      default: '',
    },

    bodyClass: {
      type: String,
      default: '',
    },

    headerClass: {
      type: String,
      default: '',
    },

    toggleDownIcon: {
      type: String,
      default: 'far fa-chevron-down',
    },

    toggleUpIcon: {
      type: String,
      default: 'far fa-chevron-up',
    },

    renderType: {
      type: String,
      validator: (prop?: 'if' | 'show') => ['if', 'show'].includes(prop ?? 'if'),
      default: 'if',
    },
  },

  computed: {
    theLabel(): string {
      return decodeHtml(this.label || '').replace(/<\/?[^>]+(>|$)/g, '');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.fa-heartbeat{
  color: $error;
}
.active-header{
  background: $tertiary-gray !important;
  border-radius: 6px 6px 0 0;
}

</style>
